var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.disabled)?_c('div',{staticClass:"d-flex justify-content-center justify-content-lg-end"},[(_vm.show_locked)?_c('vb-button',{attrs:{"vb_options":{
        text: 'Continua',
        variant: 'info',
        size: 'lg',
        disabled: true,
        icon_disabled: 'lock',
      }}}):_vm._e()],1):_c('div',{ref:"cta_continue",staticClass:"d-flex justify-content-center justify-content-lg-end"},[_c('custom-link',{attrs:{"route_name":'quote',"wrap":'a'},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('vb-button',{attrs:{"vb_options":{
            text: 'Continua',
            variant: 'info',
            size: 'lg',
          }}})]},proxy:true}])})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }